








































































































































import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import {
  ITemplatesProviderData,
  ITemplatesProviderMethods
} from "@/models/providers/templates";
import { ITemplate } from "@/models/templates";

@Component({
  components: {
    "template-preview-dropdown": () =>
      import("@/components/app/global/templates/templatePreviewDropdown.vue")
  }
})
export default class TemplatesListSelect extends Vue {
  // Inject

  @Inject({ from: "templatesProvider" })
  public templatesProvider!: () => ITemplatesProviderData;

  @Inject({ from: "templatesProviderMethods" })
  public $templatesMethods!: ITemplatesProviderMethods;

  // Props

  @Prop({ default: false })
  public value!: ITemplate | ITemplate[];

  @Prop({ default: false })
  public isMultiselect!: boolean;

  // Data

  public isProcessing: ITemplate["id"][] = [];

  // Computed

  public get $templatesData() {
    return this.templatesProvider();
  }

  public get selected() {
    return this.value as any;
  }

  public set selected(template: ITemplate) {
    if (this.isMultiselect) {
      const selected = (this.value || []) as ITemplate[];
      // Remove template
      if (this.$_.find(selected, ["id", template.id])) {
        this.$emit(
          "input",
          this.$_.filter(selected, ({ id }) => template.id !== id)
        );
        return; // Exit
      }
      // Push template
      this.$emit("input", this.$_.unionBy(selected, [template], "id"));
      return; // Exit
    }

    if (this.selected?.id === template.id) {
      // Deselect single template
      this.$emit("input", null);
      return;
    }

    // Select single template
    this.$emit("input", template);
  }

  // Methods

  public isSelected({ id }: ITemplate) {
    if (this.isMultiselect) return this.$_.find(this.selected, ["id", id]);
    return this.selected?.id === id;
  }
}
